export const DEFAULT_ROW_HEIGHT = 15;
export const EXCEL_MIME_FILE_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
export const REGEX_CELL_REFERENCE = /^[a-zA-Z]+[1-9][0-9]*$/;
